export default "__VITE_ASSET__ZzY8Y4ut__"